export const identificationTypes = {
    cc: "Cédula de ciudadania",
    ce: "Cédula de extranjería",
    pp: "Permiso especial de permanencia",
    ps: "Pasaporte"
};
